/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_Monitor_Desc7Inputs */

const en_svc_ecommerce_amazon_tools_monitor_desc7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Monitor_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Competitor prices and new reviews tracked, alerts before they cost you.`)
};

const ar_svc_ecommerce_amazon_tools_monitor_desc7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Monitor_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أسعار المنافسين والتقييمات الجديدة مرصودة، وتنبيهات قبل أن تكلفك.`)
};

const bn_svc_ecommerce_amazon_tools_monitor_desc7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Monitor_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রতিযোগীর দাম আর নতুন রিভিউ নজরে, খরচ হওয়ার আগেই সতর্কতা।`)
};

const de_svc_ecommerce_amazon_tools_monitor_desc7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Monitor_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konkurrenzpreise und neue Bewertungen werden verfolgt, Warnungen, bevor sie Sie Geld kosten.`)
};

const es_svc_ecommerce_amazon_tools_monitor_desc7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Monitor_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precios de la competencia y nuevas reseñas vigilados, alertas antes de que le cuesten dinero.`)
};

const fr_svc_ecommerce_amazon_tools_monitor_desc7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Monitor_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix concurrents et nouveaux avis surveillés, alertes avant qu'ils ne vous coûtent cher.`)
};

const pt_svc_ecommerce_amazon_tools_monitor_desc7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Monitor_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preços da concorrência e novas avaliações vigiados, alertas antes de lhe custarem dinheiro.`)
};

const zh_svc_ecommerce_amazon_tools_monitor_desc7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Monitor_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`盯着竞品价格和新增评价，亏钱之前先告警。`)
};

const tr_svc_ecommerce_amazon_tools_monitor_desc7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Monitor_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rakip fiyatlar ve yeni yorumlar takipte, size pahalıya patlamadan uyarılar.`)
};

const ru_svc_ecommerce_amazon_tools_monitor_desc7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Monitor_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цены конкурентов и новые отзывы под наблюдением, алерты до того, как это станет вам в деньги.`)
};

const pl_svc_ecommerce_amazon_tools_monitor_desc7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Monitor_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceny konkurencji i nowe opinie pod obserwacją, alerty zanim zaczną kosztować.`)
};

/**
* | output |
* | --- |
* | "Competitor prices and new reviews tracked, alerts before they cost you." |
*
* @param {Svc_Ecommerce_Amazon_Tools_Monitor_Desc7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_monitor_desc7 = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_Monitor_Desc7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_Monitor_Desc7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_monitor_desc7(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_monitor_desc7(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_monitor_desc7(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_monitor_desc7(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_monitor_desc7(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_monitor_desc7(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_monitor_desc7(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_monitor_desc7(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_monitor_desc7(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_monitor_desc7(inputs)
	return en_svc_ecommerce_amazon_tools_monitor_desc7(inputs)
});
export { svc_ecommerce_amazon_tools_monitor_desc7 as "svc_ecommerce-amazon-tools_MONITOR_desc" }